/** Fixed internal destinations; never accept an arbitrary return URL. */
export function comparisonContext(params: URLSearchParams): string {
  const result = new URLSearchParams();
  const request = params.get("quote_request_id");
  if (request && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(request))
    result.set("quote_request_id", request);
  if (params.get("show_hidden") === "1") result.set("show_hidden", "1");
  const field = params.get("field");
  if (field && /^[a-zA-Z0-9_.-]{1,160}$/.test(field)) result.set("field", field);
  return result.size ? `?${result}` : "";
}

export function comparisonSourcePath(
  submissionId: string,
  params: URLSearchParams,
  field?: string,
): string {
  const result = new URLSearchParams(comparisonContext(params));
  result.set("from", "comparison");
  if (field) result.set("field", field);
  return `/submissions/${encodeURIComponent(submissionId)}?${result}`;
}
